export const getStreamUrlForDoc = async (docId) => {
  const viewUrl = `/documents/${docId}/view`;

  const docFetchResponse = await fetch(viewUrl);
  const docFetchJson = await docFetchResponse.json();

  return docFetchJson.stream_url.replace(/&amp;/g, '&');
};
